import React, { useEffect, useState } from "react";

import MUITable from "Components/UI/Tables/MUITable";
import { IconButton, styled } from "@mui/material";

import useTableOptions from "Hooks/useTableOptions";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AttachEmail from "@mui/icons-material/AttachEmail";
import { emailReport } from "API/swesum";
import { useAuth } from "Hooks/useAuth";

const StyledTable = styled(MUITable)(({ theme }) => ({
  border: "none",
  boxShadow: "none",
  width: "100%",
  ".MuiTable-root": {
    ".MuiTableCell-root": {
      "&:nth-of-type(1)": {
        paddingTop: "0",
        paddingBottom: "0",
      },
    },
  },
}));

const createRows = (reports) => {
  return reports?.map((i) => {
    return [i.Id, i.Category, i.Name, i.CreateTime, i.IsCompleted, i.Id];
  });
};

export default function ReportTable({ reports, onDownloadReport }) {
  const [rows, setRows] = useState([]);

  const { isAdmin } = useAuth();

  const { handleColumnShow, isColDisplayed } = useTableOptions("ReportsTable");

  useEffect(() => {
    const rows = createRows(reports);
    setRows(rows);
  }, [reports]);

  const sendFile = (reportId) => {
    var test = emailReport(reportId);
  };

  const columns = [
    {
      name: "ID",
      options: {
        filter: false,
        display: isColDisplayed("ID"),
        empty: false,
      },
    },
    {
      name: "Kategori",
      options: {
        filter: false,
        display: isColDisplayed("Kategori"),
        empty: false,
      },
    },
    {
      name: "Namn",
      options: {
        display: isColDisplayed("Namn"),
        filter: false,
      },
    },
    {
      name: "Datum",
      options: {
        display: isColDisplayed("Datum"),
        filter: false,
      },
    },
    {
      name: "Skickad",
      options: {
        display: isColDisplayed("Skickad"),
        filter: false,
        customBodyRender: (isCompleted) => (isCompleted ? "Ja" : "Nej"),
      },
    },
    {
      name: "Åtgärder",
      options: {
        display: isColDisplayed("Åtgärder"),
        filter: false,
        customBodyRender: (value) => (
          <>
            <IconButton onClick={() => onDownloadReport(value)}>
              <FileDownloadIcon color="primary" />
            </IconButton>
            {isAdmin ? (
              <IconButton onClick={() => sendFile(value)}>
                <AttachEmail color="primary" />
              </IconButton>
            ) : null}
          </>
        ),
      },
    },
  ];

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    filterType: "dropdown",
    onViewColumnsChange: (changedColumn, action) =>
      handleColumnShow(changedColumn, action),
    rowsPerPageOptions: [10, 30, 100],
    textLabels: {
      body: {
        noMatch: "",
      },
    },
    downloadOptions: {
      separator: ";",
      filename: "reports.csv",
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <>
      <StyledTable options={options} data={rows} columns={columns} />
    </>
  );
}
